<template>
  <div>
    <mdb-card class="card-image image">
      <div class="text-white text-center rgba-stylish-strong py-0 px-4">
        <div class="py-5">
          <h5 class="h5 orange-text"><mdb-icon icon="barcode" /> Products</h5>
          <h2 class="card-title h2 my-2 py-1">Hardware & Software solutions</h2>
          <p class="mb-0 pb-0 px-md-5 mx-md-5">Hypertech supplys a variety of hardware and software products required by various enterprises.</p>
        </div>
      </div>
    </mdb-card>
    <div>
      <mdb-container>
        <div>
          <mdb-row>
          <mdb-col>
            <h2 class="h2 my-3 text-center">POS Hardware & Accessories</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/postouchscreen.jpg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>POS Touch-screen</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/thermalprinter.jpg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>POS Thermal printer</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/barcodescanner.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Bar-code scanners</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/cashdrawer.jpg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Cash drawers</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
        <div>
          <mdb-row>
          <mdb-col>
            <h2 class="h2 my-3 text-center">Computers & Accessories</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/desktop.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Desktops</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/laptop.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Laptops</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/storagedevices.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Storage Devices</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/printer.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>printers</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
        <div>
          <mdb-row>
          <mdb-col>
            <h2 class="h2 my-3 text-center">School edition products</h2>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-1">
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/surveillance.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Surveillance equipment</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/bellcontrol.jpg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Automatic bell control system</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/biometricaccesscontrol.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Bio-metric access control system</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
          <mdb-col col="sm">
            <mdb-card class="mx-1 margin-bottom">
              <img src="@/assets/studentmanagement.jpeg" alt="Avatar" style="object-fit: cover" height="160px" width="100%">
              <div class="container">
                <h5><b>Student management system</b></h5>
              </div>
            </mdb-card>
          </mdb-col>
        </mdb-row>
        </div>
      </mdb-container>
      <mdb-container class="my-5">
         <mdb-row>
            <mdb-col>
              <h2 class="h2 my-3 text-center">Bulk SMS services</h2>
            </mdb-col>
          </mdb-row>
          <mdb-row class=" justify-content-center">
              <mdb-col xl="9" class="pb-2">
                <img src="@/assets/sms.png" alt="sms" height="500px" class="img-fluid">
              </mdb-col>
        </mdb-row>
      </mdb-container>
    </div>
  </div>
</template>

<script>
import mdbCard from 'mdbvue/lib/components/mdbCard'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbContainer from 'mdbvue/lib/components/mdbContainer'
import mdbRow from 'mdbvue/lib/components/mdbRow'
import mdbCol from 'mdbvue/lib/components/mdbCol'

export default {
  name: 'Products',
  components: {
    mdbCard,
    mdbIcon,
    mdbContainer,
    mdbRow,
    mdbCol
  }
}
</script>

<style scoped>
.margin-bottom{
  margin-bottom: 20px;
}
.image {
  background: url("../assets/background2.jpeg");
}
</style>
